"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Text = {
    baseStyle: {
        color: 'my-body-text',
    },
    sizes: {
        xs: {
            fontSize: '0.6875rem',
            lineHeight: '1rem',
        },
        sm: {
            fontSize: '0.8125rem',
            lineHeight: '1.125rem',
            letterSpacing: '0.016rem',
        },
        md: {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
        lg: {
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
        },
    },
    variants: {
        OptionalField: {
            color: 'gray.medium',
            fontSize: '2xs',
            fontWeight: '400',
            fontStyle: 'italic',
            lineHeight: '0.875rem',
        },
    },
};
exports.default = Text;
